import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { FaSearch, FaUserPlus } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useUserContext } from '../../context/UserContext'
import secureLocalStorage from 'react-secure-storage'
import { Spinner, Toast, ToastContainer } from 'react-bootstrap'

const Skeleton = ({ number }) => {
    return (
        [...Array(number)].map((_, index) => (
            <div className='memberTile' key={index}>
                <div className='userPrty' style={{ display: 'flex', alignItems: 'center', width: '180px' }}>
                    <div className="skeletonasd avatar-skeleton mb-0 me-2" style={{ width: '35px', height: '35px' }}></div>
                    <div className="skeletonasd text-skeleton medium"></div>
                </div>
                <div className="skeletonasd btn-skeleton mt-0" style={{ width: '70px' }}></div>
            </div>
        ))
    );
};

const Invites = ({ group, create }) => {
    const [members, setMembers] = useState([]);
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
    const { Notify } = useUserContext();
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [inviting, setInviting] = useState(null);
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const entityLabel = group?.type === 'company' ? 'company' : 'group';
    const EntityLabel = group?.type === 'company' ? 'Company' : 'Group';

    const getMembers = () => {
        setLoading(true);
        axios.post("https://buzzinguniverse.com/backend/api/friend-list",
            { userid: auth?.id, type: 2 },
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        )
            .then((res) => {
                const friendsList = res.data.data || [];
                if (search.trim()) {
                    const filtered = friendsList.filter(friend =>
                        friend.user_data.first_name.toLowerCase().includes(search.toLowerCase()) ||
                        friend.user_data.last_name.toLowerCase().includes(search.toLowerCase())
                    );
                    setMembers(filtered);
                } else {
                    setMembers(friendsList);
                }
            })
            .catch(err => {
                console.error("Error fetching friends:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getMembers();
        window.scrollTo(0, 800);
    }, []);


    const InviteUser = async (e, userId) => {
        e.preventDefault();
        setInviting(userId);
        const friend = members.find(mem => mem.user_data.id === userId);
        try {
            await Notify(userId, `${auth.fname} invites you to join ${group.name}`, `/company/${group.id}/${group.name.replace(/\s+/g, '-').toLowerCase()}`);
            setToastMessage(`${friend.user_data.first_name} ${friend.user_data.last_name} has been invited to "${group.name}"`);
            setShowToast(true);
        } catch (error) {
            console.error("Invite failed:", error);
            alert("Failed to send invitation.");
        } finally {
            setInviting(null);
        }
    };

    return (
        <div className="group-settings-container">
            <h2 className="group-settings-header mb-4">Invite Followers</h2>

            <div className="search-groups-box mb-3">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    getMembers();
                }} className="d-flex align-items-center">
                    <input
                        type="text"
                        className="form-control me-2"
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search Followers..."
                        style={{ maxWidth: 300 }}
                    />
                    <button type="submit" className="btn btn-primary">
                        <FaSearch />
                    </button>
                </form>
            </div>
            {/* Toast Message */}
            <ToastContainer className="my-3 position-relative w-100">
                <Toast className='w-100' show={showToast} onClose={() => setShowToast(false)} delay={4000} autohide bg="success">
                    <Toast.Header>
                        <strong className="me-auto">Invitation Sent</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
            <div className="memberTiles mb-4">
                {loading ? (
                    <Skeleton number={6} />
                ) : (
                    members.map((mem) => (
                        <div className="memberTile d-flex justify-content-between align-items-center p-2 border rounded mb-2" key={mem.user_data.id}>
                            <div className="userPrty d-flex align-items-center">
                                <img
                                    src={mem.user_data.photo ? `https://buzzinguniverse.com/backend/${mem.user_data.photo}` : '/images/b.png'}
                                    alt="avatar"
                                    className="rounded-circle me-2"
                                    style={{ width: 35, height: 35, objectFit: 'cover' }}
                                />
                                <Link to={`/member/${mem.user_data.id}/profile`} className="text-decoration-none fw-semibold">
                                    {mem.user_data.first_name} {mem.user_data.last_name}
                                </Link>
                            </div>
                            <button
                                disabled={inviting === mem.user_data.id}
                                onClick={(e) => InviteUser(e, mem.user_data.id)}
                            >
                                {inviting === mem.user_data.id ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-1" />
                                        Inviting...
                                    </>
                                ) : (
                                    <>
                                        <FaUserPlus className="me-1" />
                                        Invite
                                    </>
                                )}
                            </button>
                        </div>
                    ))
                )}
            </div>
            {
                create && group?.name && <Link className='btncs' to={`/company/${group.id}/${group.name.replace(/\s+/g, '-').toLowerCase()}`}>View {EntityLabel}</Link>
            }


        </div>
    );
};

export default Invites;
